import { render, staticRenderFns } from "./model1.vue?vue&type=template&id=b19c35ee&scoped=true"
import script from "./model1.vue?vue&type=script&lang=js"
export * from "./model1.vue?vue&type=script&lang=js"
import style0 from "./model1.vue?vue&type=style&index=0&id=b19c35ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19c35ee",
  null
  
)

export default component.exports